import { render, staticRenderFns } from "./BTextInputWithValidation.vue?vue&type=template&id=0b681791"
import script from "./BTextInputWithValidation.vue?vue&type=script&lang=js"
export * from "./BTextInputWithValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports